var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mailbox" },
    [
      _c(
        "div",
        { staticClass: "mailbox-list_btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.show = true
                },
              },
            },
            [_vm._v("我要写信")]
          ),
        ],
        1
      ),
      _vm.listTotal > 0
        ? _c("div", { staticClass: "mailbox-list" }, [
            _c(
              "div",
              { staticClass: "mailbox-list_tab" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266",
                      },
                      data: _vm.list,
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "created_at",
                        label: "发布时间",
                        align: "center",
                        width: "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "发布内容", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                _c("p", [_vm._v(_vm._s(scoped.row.content))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2911231187
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reply_time",
                        label: "回复时间",
                        align: "center",
                        width: "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "回复内容", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                _c("p", [_vm._v(_vm._s(scoped.row.reply))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        656059720
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mailbox-list_page" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.condition.limit,
                    "current-page": _vm.condition.page,
                    background: "",
                    layout: "prev, pager, next",
                    total: _vm.listTotal,
                  },
                  on: { "current-change": _vm.getListFn },
                }),
              ],
              1
            ),
          ])
        : _vm.listTotal == 0
        ? _c(
            "div",
            { staticClass: "mailbox-no" },
            [_c("ComponentEmpty", { attrs: { title: "暂无信件", tips: "" } })],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "我要写信",
            visible: _vm.show,
            width: "500px",
            "before-close": () => {
              _vm.show = false
            },
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "mailbox-pop" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: { model: _vm.form, rules: _vm.rules },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder:
                            "请详细描述您的建议、意见及问题。有助于我们更快的发现和解决问题",
                          rows: "10",
                          "show-word-limit": "",
                          maxlength: "500",
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.show = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }